import { render, staticRenderFns } from "./LoanDetail.vue?vue&type=template&id=f5b5311c&scoped=true&"
import script from "./LoanDetail.vue?vue&type=script&lang=js&"
export * from "./LoanDetail.vue?vue&type=script&lang=js&"
import style0 from "./LoanDetail.vue?vue&type=style&index=0&id=f5b5311c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b5311c",
  null
  
)

export default component.exports